import { PropsWithChildren, useMemo } from "react";
import { MmGbState } from "./mm-gb-state";
import { GreaseGrowthbookProvider } from "@made-people/grease-growthbook";
import { defaultProps } from "../../config/default-props";
import { ManagedPropsProviderProps } from "@made-people/managed-props";
import { createSyncGrowthbookClient } from "./create-growthbook-client";
import type { GrowthbookConfiguration } from "@made-people/nestjs-bff-service";

/**
 * Passes the payload delivered from edge into the Grease Growthbook setup.
 */
export function MmGrowthbookProvider(
  props: PropsWithChildren<{
    gbState?: MmGbState;
    growthbookConfig?: GrowthbookConfiguration["publicConfiguration"];
  }>,
) {
  const client = useMemo(
    () =>
      createSyncGrowthbookClient(props.gbState, props.growthbookConfig, {
        // Isomorphic lordship
        streaming: typeof window !== "undefined",
      }),
    [],
  );

  const managedPropsProviderProps: ManagedPropsProviderProps = {
    value: {
      fallbackProps: defaultProps,
    },
  };

  return (
    <GreaseGrowthbookProvider
      clientProviderProps={{
        client,
        viewedExperiments: props.gbState?.e,
      }}
      managedProps={managedPropsProviderProps.value}
    >
      {props.children}
    </GreaseGrowthbookProvider>
  );
}
